import React from 'react';
import { connect } from 'react-redux';
import PageError from '../components/page-error/page-error';
import { StoreState } from '../redux/reducers/store.types';
import { RouterContext, RouterState } from '../types/router';
import { navigation } from '../utils';
import { redirect } from '../utils/navigation';
import { getRouter } from './router.selectors';

interface OwnProps {
  path: string;
  redirectToPath: string;
}

interface StateProps {
  router: RouterState;
}

type Props = OwnProps & StateProps;

export class RedirectRouteComponent extends React.PureComponent<Props> {
  private readonly id: string = '';

  constructor(props) {
    super(props);
    const { path } = props;

    this.id = path;
    navigation.goToPage(path, this.handleNavigation.bind(this));
  }

  public handleNavigation(context: RouterContext) {
    redirect(this.props.redirectToPath);
  }

  public render() {
    const { router } = this.props;

    if (router.path === this.id) {
      if (router.error) {
        return <PageError />;
      }

      return <p>You'll be redirected...</p>;
    }

    return null;
  }
}

const mapStateToProps = (state: StoreState): StateProps => ({
  router: getRouter(state),
});

export const RedirectRoute = connect<StateProps, null, OwnProps>(
  mapStateToProps,
)(RedirectRouteComponent);
